webpackJsonp([217608791355300],{

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(85);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _materialUi = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      padding: theme.spacing.unit * 2
	    }
	  };
	};
	
	var InfoPage = function InfoPage(_ref) {
	  var classes = _ref.classes;
	  return _react2.default.createElement(
	    _materialUi.Typography,
	    { component: "div", className: classes.root },
	    _react2.default.createElement(
	      "h1",
	      null,
	      "Hello peeps"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Once apon a time I created an iPhone app called \"Legevakter i Norge\" (Emergency Rooms in Norway)."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Then the API was shut down, life came in the way and more importantly; maintaining an iPhone app is a painful thing."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Today (March 4th, 2018) I found the API was back up! So the plan is to slowly build it back up, but this time as an easy to maintain web/JAMStack app."
	    ),
	    _react2.default.createElement(
	      "h2",
	      null,
	      "JAMStack plan"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Gatsby deployed on Netlify with Mapbox for the map feature."
	    ),
	    _react2.default.createElement(
	      "h2",
	      null,
	      "Status"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "View current state of the ",
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "app" },
	        "app"
	      ),
	      "."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "As of March 5th it is a crude list of all Norwegian Emergency Rooms."
	    ),
	    _react2.default.createElement(
	      "h2",
	      null,
	      "Journal"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "I tweet as I code, resulting in a\xA0",
	      _react2.default.createElement(
	        "a",
	        { href: "https://twitter.com/i/moments/970276387901886465" },
	        "journal you can find on Twitter."
	      )
	    )
	  );
	};
	
	exports.default = (0, _materialUi.withStyles)(styles)(InfoPage);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-info-js-3a8ec90c228390319cf9.js